import { createReducer, on } from '@ngrx/store';

import { accountNavigationFavoritesActions } from './account-navigation-favorites.actions';

export interface AccountNavigationFavoritesState {
  favoriteIds: string[];
}

const initialState: AccountNavigationFavoritesState = {
  favoriteIds: [],
};

/** adds the id if it is not a favorite yet, removes it otherwise */
function toggle(favoriteIds: string[], id: string): string[] {
  return favoriteIds.includes(id) ? favoriteIds.filter(favoriteId => favoriteId !== id) : [...favoriteIds, id];
}

export const accountNavigationFavoritesReducer = createReducer(
  initialState,

  // the favorites of the user profile are the truth, they are taken over whenever the profile changes
  on(
    accountNavigationFavoritesActions.syncAccountNavigationFavorites,
    (state, action): AccountNavigationFavoritesState => ({
      ...state,
      favoriteIds: action.payload.favoriteIds,
    })
  ),

  // the favorite is toggled right away so the card reacts immediately, the profile is saved afterwards
  // and syncs the state back once the server confirmed or rejected it
  on(
    accountNavigationFavoritesActions.toggleAccountNavigationFavorite,
    (state, action): AccountNavigationFavoritesState => ({
      ...state,
      favoriteIds: toggle(state.favoriteIds, action.payload.id),
    })
  )
);
